import { ENV } from '@shared/config';

export const links = {
  termsOfUse: ENV.VITE_TERMS_OF_USE_URL,
  privacyPolicy: ENV.VITE_PRIVACY_POLICY_URL,
  portal: 'https://portalnexpro.com.br/',
  checkout: {
    main: `/checkout`,
    plans: `/checkout/plans`,
    data: `/checkout/data`,
    installation: `/checkout/installation`,
    payment: `/checkout/payment`,
    summary: `/checkout/summary`,
    success: `/checkout/success`,
  },
  crossSeller: {
    main: `/cross-seller`,
    plans: `/cross-seller/plans`,
    payment: `/cross-seller/payment`,
    summary: `/cross-seller/summary`,
    success: `/cross-seller/success`,
  },
  onboarding: {
    main: `/onboarding`,
    companyData: `/onboarding/company-data`,
    addResponsible: `/onboarding/add-responsible`,
    sended: `/onboarding/sended`,
    chassis: `/onboarding/chassis`,
    summary: `/onboarding/summary`,
    installation: `/onboarding/installation`,
  },
};
